import { defineStore } from "pinia";
import { ref } from "vue";

export const useGlobalStore = defineStore(
  "globalStoreDetails",
  () => {
    const sitecoreData: any = ref(null);

    const updateSitecoreData = (data: any) => {
      sitecoreData.value = data;
    };
    return {
      sitecoreData,
      updateSitecoreData
    };
  },
  {
    persist: false
  }
);
